import React from "react";
import style from "../Application.module.scss";
import SkeletonLoader from "../../../components/skeleton-loader";

function ApplicationDetailsSkeleton() {
  return (
    <>
      <div className={style.skeletonHeader}>
        <div className={style.skeletonHeaderRow}>
          <div className={style.skeletonHeaderLeftTop}>
            <SkeletonLoader variant="circular" width="24px" height="24px" />
            <SkeletonLoader variant="text" width="102px" height="24px" />
          </div>
          <div className={style.skeletonMenu}>
            <SkeletonLoader
              variant="circular"
              width="24px"
              height="24px"
              style={{ marginRight: "16px" }}
            />
          </div>
        </div>

        <div className={style.skeletonHeaderRow}>
          <div className={style.skeletonHeaderLeft}>
            <SkeletonLoader
              variant="text"
              width="150px"
              height="25px"
              className={style.skeletonTitle}
            />
            <div className={style.skeletonHeaderLeftBottom}>
              <SkeletonLoader
                variant="text"
                width="100px"
                height="29px"
                className={style.skeletonButton}
              />
            </div>
          </div>
          <div className={style.skeletonActions}>
            <SkeletonLoader
              variant="rectangular"
              style={{ borderRadius: "8px" }}
              width="48px"
              height="32px"
            />
            <SkeletonLoader
              variant="rectangular"
              style={{ borderRadius: "8px" }}
              width="114px"
              height="32px"
            />
          </div>
        </div>
      </div>

      <div className={style.skeletonMobileHeader}>
        {/* <div className={style.skeletonMobileHeaderTop}>
          <SkeletonLoader variant="circular" width="24px" height="24px" />
        </div> */}

        <div className={style.skeletonMobileHeaderContent}>
          <SkeletonLoader
            variant="text"
            width="180px"
            height="32px"
            style={{ borderRadius: "8px" }}
          />
          <SkeletonLoader
            variant="rectangular"
            width="100px"
            height="24px"
            style={{ borderRadius: "12px" }}
          />
        </div>
      </div>

      <div className={style.skeletonContent}>
        {[1, 2, 3, 4, 5, 6].map((column) => (
          <div key={`skeleton-data-item-${column}`}>
            <SkeletonLoader
              variant="text"
              width="40px"
              height="16px"
              className={style.skeletonTextLine}
            />
            <SkeletonLoader
              variant="text"
              width="100px"
              height="22px"
              className={style.skeletonTextLine}
            />
          </div>
        ))}
      </div>

      <div className={style.skeletonTabs}>
        {[1, 2, 3, 4, 5, 6].map((tab) => (
          <SkeletonLoader
            key={`tab-${tab}`}
            variant="rectangular"
            width="90px"
            height="24px"
            className={style.skeletonTab}
          />
        ))}
      </div>

      <div className={style.skeletonAccordion}>
        {[1, 2, 3, 4, 5, 6].map((accordion) => (
          <div
            key={`skeleton-accordion-${accordion}`}
            className={style.skeletonAccordionItem}
          >
            <div>
              <SkeletonLoader
                variant="rectangular"
                width="24px"
                height="24px"
              />
              <SkeletonLoader
                variant="rectangular"
                width="183px"
                height="23px"
              />
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default ApplicationDetailsSkeleton;
